import type { Asset } from 'contentful';

import { useContentfulContentTypeEntry } from '@order/Contentful';

// ─────────────────────────────────────────────────────────────────────────────

export const useGiftCards = () => {
  const { data, error, fetching } = useContentfulContentTypeEntry<GiftCards>({
    contentType: 'giftCardsScreen',
    include: 3,
  });

  const {
    heading,
    subheading,
    subheadingLinkText,
    giftCardCategories = [],
  } = data?.fields ?? {};

  return {
    error,
    fetching,
    data: {
      giftCardCategories,
      heading,
      subheading,
      subheadingLinkText,
    },
  };
};

// ─── Types ───────────────────────────────────────────────────────────────────

type GiftCards = {
  heading: string;
  subheading: string;
  subheadingLinkText: string;
  giftCardCategories: {
    fields: {
      category: string;
      giftCards: {
        fields: {
          id: string;
          title: string;
          cover: Asset;
          coverStatic?: Asset;
        };
      }[];
      id: string;
    };
  }[];
};
